import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { MB_ANALYTICS_ADAPTER_READY, MB_ANALYTICS_FEATURE_FLAG_TRACK_EVENT, MB_ANALYTICS_PARTIAL_EVENT, OPTIMIZELY_ADD_FAVOURITE_EVENT_KEY } from '../constants';
const buildSelectionString = (...args) => args.filter(arg => !!arg).join('|');
const publishByoAnalytics = (payload) => {
    publish('event:byo', payload);
};
const publishSecondayNavigationAnalytics = (payload) => {
    publish('event:secondarynavigation', payload);
};
export const publishOnLoginOpen = () => {
    publishSecondayNavigationAnalytics({ Tab: 'BuildYourOdds', Action: 'LoginModalOpened' });
};
export const publishOnByoOpen = () => {
    publishSecondayNavigationAnalytics({ Tab: 'BuildYourOdds', Action: 'BYOModalOpened' });
};
export const publishAccordionAnalytics = (status, name) => {
    publishByoAnalytics({ Action: status ? 'CollapseMarket' : 'ExpandMarket', Name: name });
};
export const publishOnCloseAnalytics = () => {
    publishByoAnalytics({ Action: 'Closed' });
};
export const publishViewSelectionsAnalytics = () => {
    publishByoAnalytics({ Action: 'ViewSelection' });
};
export const publishCloseReviewAnalytics = () => {
    publishByoAnalytics({ Action: 'ReviewSelected' });
};
export const publishClearSlipAnalytics = () => {
    publishByoAnalytics({ Action: 'SelectionsCleared' });
};
export const publishAddToBetslipFastAnalytics = () => {
    publishByoAnalytics({ Action: 'AddtoBetslipFast' });
};
export const publishAddToBetslipReviewAnalytics = () => {
    publishByoAnalytics({ Action: 'AddtoBetslipReview' });
};
export const publishPeriodAnalytics = (categoryName, period) => {
    publishByoAnalytics({
        Action: 'PeriodSelected',
        Name: buildSelectionString(categoryName, period)
    });
};
export const publishSelectionAddAnalytics = ({ categoryName, period, name, team }) => {
    publishByoAnalytics({
        Action: 'SelectionAdded',
        Name: buildSelectionString(name, categoryName, team, period)
    });
};
export const publishSelectionRemoveAnalytics = ({ categoryName, period, name, team }) => {
    publishByoAnalytics({
        Action: 'SelectionRemoved',
        Name: buildSelectionString(name, categoryName, team, period)
    });
};
export const publishOnDeleteBinClick = () => {
    publishByoAnalytics({
        Action: 'SelectionBinned'
    });
};
export const publishTeamTabSelectAnalytics = (categoryName, team) => {
    publishByoAnalytics({
        Action: 'TeamTabSelected',
        Name: buildSelectionString(categoryName, team)
    });
};
const publishOptimizelyTrackEvent = (eventName) => {
    publish(MB_ANALYTICS_FEATURE_FLAG_TRACK_EVENT, { eventName });
};
export const publishOptimizelyAddFavouriteEvent = () => {
    publishOptimizelyTrackEvent(OPTIMIZELY_ADD_FAVOURITE_EVENT_KEY);
};
const whenAnalyticsAdapterReady = (callback) => {
    const token = subscribe(MB_ANALYTICS_ADAPTER_READY, () => {
        unsubscribe(token);
        callback();
    });
};
export const publishAddMarketToFavouritesAnalytics = (marketName) => {
    whenAnalyticsAdapterReady(() => {
        publish(MB_ANALYTICS_PARTIAL_EVENT, {
            event: 'link',
            payload: {
                EventCategory: 'Test Events',
                EventAction: 'WILS-2044',
                EventLabel: `${marketName} - Favourited`,
                NonInteractionEvent: '0',
                ElementType: ''
            }
        });
    });
};
export const publishOpenByoMenuAnalytics = () => {
    whenAnalyticsAdapterReady(() => {
        publish(MB_ANALYTICS_PARTIAL_EVENT, {
            event: 'link',
            payload: {
                EventCategory: 'Test Events',
                EventAction: 'WILS-2044',
                EventLabel: 'BYO Menu',
                NonInteractionEvent: '0',
                ElementType: ''
            }
        });
    });
};
